import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useHtmlClassService } from "../../../../../_metronic/layout/_core/MetronicLayout";
import { Topbar } from "../../../../../_metronic/layout/components/header/Topbar";
import { HeaderMenuWrapper } from "../HeaderMenuWrapper";

export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  return (
    <>
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
        >
          <div className="d-flex align-items-stretch mr-3">
            <div className="header-logo">
              <Link to="/">
                <img
                  className="logo-default max-h-40px d-print-none"
                  alt="Logo"
                  src={toAbsoluteUrl("/media/logos/logo-letter-9.png")}
                />
                <img
                  className="logo-sticky max-h-40px"
                  alt="Logo"
                  src={toAbsoluteUrl("/media/logos/logo-letter-1.png")}
                />
              </Link>
            </div>
            {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          </div>
          <Topbar showSelectStores={false} showApiAccess={false} />
        </div>
      </div>
    </>
  );
}
